import React from 'react'

const ErrorPage = () => {
  return (
    <div>404 error</div>
  )
}

export default ErrorPage;